import { Contract } from './contract';
import { LeaseAgreementCategory, OrganizationOfTenantsKind, RentalObjectCategory } from './const/enums';
import { DwellingInspection } from '../../dwelling-inspection/model/dwelling-inspection';
import { LeaseAgreementForm } from './lease-agreement-form';
import { SubleaseRequest } from './sublease-request';
import { CooperativeHousingOwner } from './CooperativeHousingOwner';
import { BrfMortgagePrescription } from './brf-mortgage-prescription';
import { BrfTransfer } from './Transfer/brftransfer';

export class CooperativeHousingContract extends Contract {
  constructor() {
    super(LeaseAgreementCategory.CooperativeHousing);
    this.subleaseRequests = [];
    this.owners = [];
    this.brfMortgagePrescriptions = [];
  }

  private _subleaseRequest: SubleaseRequest[] = [];

  get subleaseRequests(): SubleaseRequest[] {
    return this._subleaseRequest;
  }
  set subleaseRequests(items: SubleaseRequest[]) {
    if (items instanceof Array) {
      items.forEach(item => {
        if (item instanceof SubleaseRequest) this._subleaseRequest.push(item);
        else this._subleaseRequest.push(Object.assign(new SubleaseRequest(), item));
      });
    }
  }

  private _brfMortgagePrescriptions: BrfMortgagePrescription[] = [];

  get brfMortgagePrescriptions(): BrfMortgagePrescription[] {
    return this._brfMortgagePrescriptions;
  }
  set brfMortgagePrescriptions(items: BrfMortgagePrescription[]) {
    if (items instanceof Array) {
      items.forEach(item => {
        if (item instanceof BrfMortgagePrescription) this._brfMortgagePrescriptions.push(item);
        else this._brfMortgagePrescriptions.push(Object.assign(new BrfMortgagePrescription(), item));
      });
    }
  }

  owners: CooperativeHousingOwner[];
  rentalObjectCategory: RentalObjectCategory;
  atticStorageNumber: string;
  basementStorageNumber: string;
  otherStorageNumber: string;
  parkingIncludedInRent: string;
  currencyCode: string;
  brfTransfer: BrfTransfer;

  toJSON() {
    let json = super.toJSON();
    json.subleaseRequests = this.subleaseRequests;
    json.brfMortgagePrescriptions = this.brfMortgagePrescriptions;

    return json;
  }
}
